// import parsePhoneNumber from "libphonenumber-js";
import { parsePhoneNumber } from "react-phone-number-input";
import { PhoneNumberValidation } from "../Constants/validationValues";

const messages = {
  required: "Required",
  shortText: "The text is too short",
  longText: "The text is too long",
  // InvalidEmail: "The email is not valid",
  shortPassword: "The password is too short",
  invalidPassword:
    "Passwords must contain at least eight characters, including at least 1 uppercase letter and 1 number",
  invalidURL: "Invalid URL",
  incomplete: "Incomplete",
  error: "Error",
  invalidPhoneNumber: "Invalid Phone Number",
  unsupportedCountryCode: "Unsupported phone country code. Valid only US, MX, TW, TC",
};

const hasLength = (value: any) => {
  if (typeof value === "string") {
    if (value.trim().length > 0) {
      return true;
    }
  }
  if (typeof value === "object" && value.length > 0) {
    return true;
  } else if (typeof value === "object") {
    const temp = Object.values(value);
    if (temp.length > 0) {
      return true;
    }
  }
  return false;
};

const hasMaxLength = (value: string, maxLength: number) => {
  if (value.length <= maxLength) {
    return true;
  }
  return false;
};

const hasMinLength = (value: string, minLength: number) => {
  if (value.length >= minLength) {
    return true;
  }
  return false;
};

const isValidEmail = (value: string) => {
  if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return true;
  }
  return false;
};

export const isValidURL = (value: string) => {
  if (
    // eslint-disable-next-line no-useless-escape
    /^https:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/m.test(
      value
    )
  ) {
    return true;
  }
  return false;
};

const isStrongPassword = (value: string) => {
  if (/^(?=^.{8,}$)(?=.*\d)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/m.test(value)) {
    return true;
  }
  return false;
};

/////////////////////////////////////////////
export const emailValidation = (value: string) => {
  if (!hasLength(value)) {
    return messages.required;
  }
  // else if (!hasMinLength(value, 10)) {
  //   return "shortText";
  // } else if (!hasMaxLength(value, 100)) {
  //   return "LongText";
  // } else if (!isValidEmail(value)) {
  //   return "InvalidEmail";
  // } else {
  return null;
  // }
};

export const textValidation = (
  value: string,
  minLength: number,
  maxLength: number,
  isRequired: boolean = true
) => {
  if (isRequired && !hasLength(value)) {
    return messages.required;
  } else if (!hasMinLength(value, minLength)) {
    return messages.shortText;
  } else if (!hasMaxLength(value, maxLength)) {
    return messages.longText;
  } else {
    return null;
  }
};

export const reactSelectValidation = (value: any) => {
  if (!value) {
    return messages.required;
  }
  if (!hasLength(value)) {
    return messages.required;
  } else {
    return null;
  }
};

export const urlValidation = (value: string, isRequired: boolean = true) => {
  if (isRequired && !hasLength(value)) {
    return messages.required;
  } else if (isRequired && !hasMinLength(value, 2)) {
    return messages.shortText;
  } else if (!hasMaxLength(value, 50)) {
    return messages.longText;
  } else if (value.length && !isValidURL(value)) {
    return messages.invalidURL;
  } else {
    return null;
  }
};

export const passwordValidation = (value: string) => {
  if (!hasLength(value)) {
    return messages.required;
  } else if (!hasMinLength(value, 8)) {
    return messages.shortPassword;
  } else if (!hasMaxLength(value, 50)) {
    return messages.longText;
  } else if (value.length && !isStrongPassword(value)) {
    return messages.invalidPassword;
  } else {
    return null;
  }
};

export const requiredPasswordValidation = (value: string) => {
  if (!hasLength(value)) {
    return messages.required;
  }
};

export const languageValidation = (value: string) => {
  if (!hasLength(value)) {
    return messages.required;
  } else {
    return null;
  }
};

export const ipAddressValidation = (value: string, isRequired: boolean = true) => {
  if (!value) {
    return messages.required;
  }
  if (isRequired && value && !value.length) {
    return messages.required;
  }
  const subips: string[] = value.split(".");
  if (
    isRequired &&
    subips[0].length === 0 &&
    subips[1].length === 0 &&
    subips[2].length === 0 &&
    subips[3].length === 0
  ) {
    return messages.required;
  } else if (
    !(subips[0].length > 0 && subips[1].length > 0 && subips[2].length > 0 && subips[3].length > 0)
  ) {
    if (!isRequired && (value === "..." || value === "")) {
      return null;
    }
    return messages.incomplete;
  } else if (
    !(
      parseInt(subips[0]) > 0 &&
      parseInt(subips[0]) < 256 &&
      parseInt(subips[1]) >= 0 &&
      parseInt(subips[1]) < 256 &&
      parseInt(subips[2]) >= 0 &&
      parseInt(subips[2]) < 256 &&
      parseInt(subips[3]) >= 0 &&
      parseInt(subips[3]) < 256
    )
  ) {
    if (!isRequired && (value === "..." || value === "")) {
      return null;
    }
    return messages.error;
  } else {
    return null;
  }
};

// Phone Number Validation

export const phoneNumberValidation = (value: string) => {
  if (!isValidPhoneNumber(value)) {
    return messages.invalidPhoneNumber;
  } else {
    let counterError = false;
    for (let i = 0; i < PhoneNumberValidation.supportedCountries.length; i++) {
      if (
        PhoneNumberValidation.supportedCountries.length &&
        isPhoneNumberCodeValid(value, PhoneNumberValidation.supportedCountries[i].toUpperCase())
      ) {
        counterError = false;
        break;
      } else {
        counterError = true;
      }
    }
    if (counterError) {
      return messages.unsupportedCountryCode;
    } else {
      return null;
    }
  }
};

const isValidPhoneNumber = (value: string) => {
  const phoneNumber = parsePhoneNumber(value);
  if (phoneNumber?.isValid()) {
    return true;
  }
  return false;
};

const isPhoneNumberCodeValid = (value: string, code: string) => {
  const phoneNumber = parsePhoneNumber(value);
  if (phoneNumber?.country === code) {
    return true;
  }
  return false;
};

// Card Id Validation

export const cardNumberValidation = (value: number) => {
  if (!value) {
    return messages.required;
  } else {
    return null;
  }
};

// Facility Code Validation

export const facilityCodeValidation = (value: number) => {
  if (!value) {
    return messages.required;
  } else {
    return null;
  }
};
